export const DESIGN_HISTORY_LINKS = [
  {
    label: 'Original refinement audit',
    description: 'The findings that established the Paper redesign brief.',
    href: 'https://github.com/tadoku/tadoku/blob/62536c7988107f6856c83cf443735638230937ed/docs/wip/tadoku-paper/artifacts/design-system-refinement-audit.html',
  },
  {
    label: 'Visual studies',
    description: 'Approved and rejected directions from Bookplate through the final component grammar.',
    href: 'https://github.com/tadoku/tadoku/tree/62536c7988107f6856c83cf443735638230937ed/docs/wip/tadoku-paper/artifacts',
  },
  {
    label: 'Paper decision log',
    description: 'The product and visual decisions that shaped Tadoku Paper.',
    href: 'https://github.com/tadoku/tadoku/blob/62536c7988107f6856c83cf443735638230937ed/docs/wip/tadoku-paper/decision-log.md',
  },
  {
    label: 'Implementation plan',
    description: 'The phased delivery, gates, risks, and migration sequence.',
    href: 'https://github.com/tadoku/tadoku/blob/62536c7988107f6856c83cf443735638230937ed/docs/wip/tadoku-paper/implementation-plan.md',
  },
  {
    label: 'Research archive',
    description: 'ADRs, inventories, compatibility evidence, and provenance.',
    href: 'https://github.com/tadoku/tadoku/tree/62536c7988107f6856c83cf443735638230937ed/docs/wip/tadoku-paper/research',
  },
] as const
